/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, makeStyles } from "@material-ui/core/";
import { useContext, useEffect, useState } from "react";
import { config as url } from "../../common/config";
import FetchDataContext from "../../context/fetchData/fetchDataContext";
import useAPI from "../../hooks/useAPI";
import FormOnEditUsers from "./FormOnEditUsers";
import FormOnUsers from "./FormOnUsers";
import TableOnUsers from "./TableOnUsers";

const useStyles = makeStyles((theme) => ({
	root: {
		paddingLeft: "2rem",
		paddingRight: "2rem",
		[theme.breakpoints.down("sm")]: {
			paddingLeft: "1rem",
			paddingRight: "1rem",
		},
	},
}));

const Users = (props) => {
	const classes = useStyles();
	const { getOptionAll } = useAPI();
	const BaseUrl = `${url.users}`;
	const fetchData = useContext(FetchDataContext);
	const { getDataTables, addData, updateData, tableRef } = fetchData;
	const [state, setState] = useState({
		openAdd: false,
		pageSize: 5,
	});
	const { openAdd, pageSize } = state;
	const [openEdit, setOpenEdit] = useState(false);
	const [data, setData] = useState();
	const [option, setOption] = useState(null);

	const handleOpenCloseFormAdd = () => {
		setState({ ...state, openAdd: !openAdd });
	};
	const handleOpenCloseFormEdit = (params) => {
		setOpenEdit(!openEdit);
		params &&
			option &&
			option.map((row) => {
				if (params.role === row.nama) {
					setData({ ...params, role: row.id });
				}
				return row;
			});
	};
	const handleFetchUpdate = () => {
		return false;
	};

	const fetchAPI = async (action, data) => {
		let result;
		if (action === "add")
			result = await addData(
				`${BaseUrl}/add_user`,
				data,
				handleOpenCloseFormAdd
			);
		if (action === "edit")
			result = await updateData(
				`${BaseUrl}/edit_user?id=${data.id}`,
				data,
				handleOpenCloseFormEdit
			);
		if (action === "editstatus_user")
			result = await updateData(
				`${BaseUrl}/edit_status?id=${data.id}`,
				data,
				handleFetchUpdate
			);
		if (action === "resetPassword")
			result = await updateData(
				`${BaseUrl}/reset?id=${data.id}`,
				"",
				handleFetchUpdate
			);
		return result;
	};

	const handleOption = async () => {
		const res = await getOptionAll(`${url.optionMaster}/role_utama`);
		setOption(res.data);
		return res.data;
	};

	useEffect(() => {
		handleOption();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<Grid direction="column" alignItems="center" className={classes.root}>
			<TableOnUsers
				getDataTables={getDataTables}
				BaseUrl={BaseUrl}
				pageSize={pageSize}
				tableRef={tableRef}
				modalAdd={handleOpenCloseFormAdd}
				modalEdit={handleOpenCloseFormEdit}
				fetchAPI={fetchAPI}
			/>
			<FormOnUsers
				open={openAdd}
				fetchAPI={fetchAPI}
				handleClose={handleOpenCloseFormAdd}
				option={option}
			/>
			<FormOnEditUsers
				open={openEdit}
				editData={data}
				handleClose={handleOpenCloseFormEdit}
				fetchAPI={fetchAPI}
				option={option}
			/>
		</Grid>
	);
};
export default Users;
